module.exports = __webpack_public_path__ + "static/media/DocumentRejected.50486e52.svg";